import axios from 'axios';
import Portal from '../../src/model/Portal'
import AuthService from '../../src/services/AuthService'
import GO1_API from '../../src/config/api'

export default {
    // get portals via API & map accounts response to portal models
    portals () {
        return axios.get(`${GO1_API}user/account/me?limit=100&offset=0`, AuthService.getAPIAuthConfig())
            .then(portalsResp => {
                return this.validPortals(portalsResp).map(portal => new Portal(portal).prepareModel());
            });
    },

    portal (portalName) {
        return axios.get(`${GO1_API}portal/${portalName}`)
            .then(portalResp => {
                return portalResp.data;
            });
    },

    validPortals(portalsResp) {
      return portalsResp.data.accounts.filter(portal => portal.hasOwnProperty('instance'));
    }
}



// WEBPACK FOOTER //
// ./src/services/PortalService.js